import React from "react"

import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import { ProductCTA, RichTitle } from ".."
import { injectIntl } from "react-intl"

const localeConsts = require("../../constants/localeConsts")

const useStyles = makeStyles(theme => ({
  root: {
    background: "#fff",
    zIndex: 0,
  },
  flexContainer: {
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.up("lg")]: {
      maxWidth: theme.spacing(162),
      padding: theme.spacing(0, 0, 10),
    },
    [theme.breakpoints.only("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4, 0),
      maxWidth: "100%",
    },
  },
  heading: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.spacing(3),
    textAlign: "center",
  },
  titleText: {
    marginTop: theme.spacing(7),
    padding: theme.spacing(0, 13),
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(0, 3),
    },
  },
  productLine: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    marginTop: theme.spacing(6),
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      flexDirection: "column",
      flexWrap: "nowrap",
    },
  },
  link: {
    textDecoration: "none",
    [theme.breakpoints.up("sm")]: {
      alignSelf: "stretch",
      flexDirection: "column",
      display: "row",
    },
    display: "flex",
  },
}))

export default injectIntl(props => {
  const classes = useStyles()

  const getProductpath = (locale, slug, isProductLine) => {
    let path = "/"
    path =
      path + (locale === localeConsts.es ? localeConsts.es : localeConsts.en)
    if (isProductLine) {
      path = path + "/line"
    }
    path =
      path +
      "/" +
      slug +
      (locale === localeConsts.es ? localeConsts.esPath : localeConsts.enPath)
    return path
  }

  const { intl } = props
  const i18nmessages = intl.messages
  const outOfStockText = i18nmessages.outOfStock

  if (props.productLineData.items.length) {
    return (
      <div className={classes.root}>
        <div className={classes.flexContainer}>
          <div className={classes.heading}>
            <Typography className={classes.titleText}>
              {props.productLineData.titleText && (
                <RichTitle titleText={props.productLineData.titleText} />
              )}
            </Typography>
          </div>
          <div className={classes.productLine}>
            {props.productLineData.items.map((product, key) => {
              let slug = `/${
                product.locale === localeConsts.es
                  ? localeConsts.es
                  : localeConsts.en
              }/line/${product.slug}${
                product.locale === localeConsts.es
                  ? localeConsts.esPath
                  : localeConsts.enPath
              }`
              return (
                <ProductCTA
                  className={classes.productCTA}
                  isSingleProduct={props.isSingleProduct}
                  productImage={product.imageSrc}
                  productName={product.title}
                  productPage={props.productPage}
                  langKey={props.langKey}
                  buttonText={
                    i18nmessages[product.buttonText]
                      ? i18nmessages[product.buttonText]
                      : product.buttonText
                  }
                  productPrice={`${
                    product.price === undefined ? "" : product.price
                  }`}
                  productTitle={`${
                    product.productTitle === undefined
                      ? ""
                      : product.productTitle
                  }`}
                  btnColor={product.btnColor}
                  color={product.color}
                  itemId={product.itemId}
                  slug={slug}
                  outOfStock={outOfStockText}
                  isOutOfStock={product.isOutOfStock}
                  isComingSoon={product.isComingSoon}
                  productLink={
                    props.isSingleProduct
                      ? getProductpath(product.langKey, product.slug, false)
                      : getProductpath(
                          product.langKey,
                          product.slug,
                          product.isProductLine
                        )
                  }
                  key={key}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  // There are no products to show, then show nothing.
  return null
})
